export function base64ToFile(base64, fileName) {
    var binaryData = atob(base64);

    // Convertir el texto decodificado a un arreglo de bytes
    var byteArray = new Uint8Array(binaryData.length);
    for (var i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
    }

    // Crear un Blob a partir de los datos binarios
    var blob = new Blob([byteArray], { type: 'application/octet-stream' });

    // Crear un enlace de descarga
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;

    // Simular un clic en el enlace para descargar el archivo
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}